/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { HighlightSegment } from './highlightSegment';

export type TaskFeedbackHighlightingAnyOf = { [key: string]: HighlightSegment[] };
